module.exports = __webpack_public_path__ + "img/9-12.b5bccd95.jpg";